const LOCAL_USERINFO = 'shopping_userinfo'
const LOCAL_HISTORY = 'local_history'
// 登录成功后会得到token
// 将个人信息保存到本地
export const setLocalUserInfoApi = (obj) => {
  localStorage.setItem(LOCAL_USERINFO, JSON.stringify(obj))
}

// 获取本地个人信息
export const getLocalUserInfoApi = () => {
  return JSON.parse(localStorage.getItem(LOCAL_USERINFO)) || { token: '', userId: '' }
}

// 移除个人信息
export const removeInfo = () => {
  localStorage.removeItem(LOCAL_USERINFO)
}

// 将搜索记录保存到本地
export const setLocalSearchHistory = (obj) => {
  localStorage.setItem(LOCAL_HISTORY, JSON.stringify(obj))
}
// 获取本地搜索记录
export const getLocalSearchHistory = () => {
  return JSON.parse(localStorage.getItem(LOCAL_HISTORY)) || []
}
